import { cn } from '@/lib/utils';
import * as RadixSwitch from '@radix-ui/react-switch';
import * as React from 'react';

const Switch = React.forwardRef<
  React.ComponentRef<typeof RadixSwitch.Root>,
  React.ComponentPropsWithoutRef<typeof RadixSwitch.Root> & {
    rootClassName?: string;
    thumbClassName?: string;
  }
>(({ rootClassName, thumbClassName, ...props }, ref) => (
  <RadixSwitch.Root
    ref={ref}
    {...props}
    className={cn(
      'relative w-6 h-4 rounded-full shadow-[0_2px_10px_var(--black-a7)]',
      'bg-zinc-400',
      'focus:outline-none focus:ring-[0.5px] focus:ring-gray-500',
      'data-[state=checked]:bg-primary',
      rootClassName,
    )}
  >
    <RadixSwitch.Thumb
      className={cn(
        'block size-2.5 bg-white rounded-full shadow-[0_2px_2px_var(--black-a7)]',
        'transition-transform duration-100 will-change-transform translate-x-[2px]',
        'data-[state=checked]:translate-x-[12px]',
        thumbClassName,
      )}
    />
  </RadixSwitch.Root>
));

Switch.displayName = 'Switch';

export { Switch };
